/**
 * @generated SignedSource<<6237adfc1e15c2e8987bb430d9b173ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TransferAppDestinationSelectorFragment_organization$data = {
  readonly id: string;
  readonly imageUrl: string | null;
  readonly name: string;
  readonly slug: string;
  readonly " $fragmentType": "TransferAppDestinationSelectorFragment_organization";
};
export type TransferAppDestinationSelectorFragment_organization$key = {
  readonly " $data"?: TransferAppDestinationSelectorFragment_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"TransferAppDestinationSelectorFragment_organization">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "TransferAppDestinationSelectorFragment_organization"
};

(node as any).hash = "9d79ea692b3ea2c56f16e270fa2671df";

export default node;
